import { push } from 'redux-first-history';
import queryString from 'query-string';
import selectors from '../../../root/shared/root';
import { getUrlString } from '../../../utils/shared/urlUtils';
import {
    SWITCH_INSTRUCTION_DATE,
    SWITCH_INSTRUCTION_GRADE,
    CLEAR_CHECKPOINTS,
    VIEW_LATEST_UPDATE_RECOMMENDATION,
} from '../../actionTypes/shared/apiActionTypes';

export const switchInstructionTab = instructionTab => (dispatch, getState) => {
    const state = getState();
    const { pathname, search } = selectors.getLocation(state);
    dispatch(
        push(
            getUrlString(pathname, {
                ...queryString.parse(search),
                instructionTab,
            }),
        ),
    );
};

export const switchInstructionDate = (payload, prevDate = '') => ({
    type: SWITCH_INSTRUCTION_DATE,
    payload,
    prevDate,
});

export const viewLatestUpdate = payload => ({
    type: VIEW_LATEST_UPDATE_RECOMMENDATION,
    payload,
});

export const switchInstructionGrade = selectedInstructionGrade => ({
    type: SWITCH_INSTRUCTION_GRADE,
    selectedInstructionGrade,
});

export const clearCheckPoints = () => ({ type: CLEAR_CHECKPOINTS });
